import React from "react";
import { Box } from "@mui/material";
import { publicPageRootSx } from "../constants/publicMarketingTheme";

/** Wraps public marketing routes with the integrations/tech page background. */
export default function PublicMarketingShell({ children, sx }) {
  return (
    <Box sx={{ ...publicPageRootSx(), ...sx }}>
      <Box sx={{ position: "relative", zIndex: 1 }}>{children}</Box>
    </Box>
  );
}
